export const portalFr = {

  // ── Onboarding survey (/portal/onboarding) ───────────────────────────────
  onboarding: {
    title: "Bienvenue — comment pouvons-nous vous aider ?",
    subtitle: "Dites-nous ce qui vous amène afin que nous puissions vous orienter au bon endroit.",
    later: "Je le ferai plus tard",
    back: "Retour",
    choices: {
      applyTitle: "Demande Thailand Elite : visa Thailand Privilege",
      applyDesc: "Commencez votre demande d'adhésion / de visa long séjour.",
      memberTitle: "Je suis déjà membre Thailand Elite",
      memberDesc: "Associez votre adhésion ou demandez un service membre.",
      prospectTitle: "J'ai des questions avant de décider",
      prospectDesc: "Obtenez des informations et échangez avec un conseiller.",
      partnerTitle: "Je représente une agence ou un partenaire",
      partnerDesc: "Découvrez les options de partenariat et de parrainage.",
      otherTitle: "Autre chose",
      otherDesc: "Un autre type de demande — dites-nous comment vous aider.",
      servicesTitle: "Immobilier, assurance et autres services",
      servicesDesc: "Immobilier, assurance, autre visa ou aide pour vous installer en Thaïlande.",
    },
    applicant: {
      heading: "Quelques questions rapides",
      subtitle: "Cela nous aide à personnaliser votre demande. Vous pourrez le modifier plus tard.",
      purposeLabel: "Quelle est votre principale raison de choisir Thailand Elite ?",
      timelineLabel: "Quand prévoyez-vous de faire votre demande ou de vous installer ?",
      submit: "Continuer vers ma demande",
    },
    purpose: {
      retirement: "Retraite / long séjour",
      business: "Affaires / travail",
      family: "Famille / personnes à charge",
      investment: "Investissement",
      lifestyle: "Style de vie / voyages fréquents",
      other: "Autre",
    },
    timeline: {
      asap: "Dès que possible",
      m1_3: "Dans 1 à 3 mois",
      m3_6: "Dans 3 à 6 mois",
      m6_12: "Dans 6 à 12 mois",
      exploring: "Je me renseigne simplement",
    },
    member: {
      heading: "Bon retour — retrouvons votre adhésion",
      subtitle: "Indiquez votre numéro de membre et notre équipe l'associera à ce compte après une vérification rapide.",
      idLabel: "Numéro de membre / de carte",
      idPlaceholder: "ex. TPC123456",
      sinceLabel: "Depuis quand êtes-vous membre ?",
      sincePlaceholder: "ex. 2022",
      viaLabel: "Comment avez-vous fait votre demande ?",
      viaPlaceholder: "Agent, direct, etc.",
      helpLabel: "Comment pouvons-nous vous aider ?",
      helpPlaceholder: "Décrivez votre demande (apposition du visa, déclaration 90 jours, renouvellement…).",
      submit: "Envoyer",
    },
    inquiry: {
      heading: "Dites-nous-en un peu plus",
      subtitle: "Nous transmettrons votre demande à la bonne personne et assurerons le suivi.",
      typeLabel: "Quel est l'objet de votre demande ?",
      messageLabel: "Votre message",
      messagePlaceholder: "Dites-nous comment nous pouvons vous aider.",
      submit: "Envoyer la demande",
    },
    inquiryTypes: {
      general_inquiry: "Question générale",
      member_service: "Membre existant — demande de service",
      partnership: "Agence / partenariat",
      visa_other: "Autre question visa / immigration",
      other_services: "Immobilier, assurance ou autres services",
      other: "Autre",
    },
    services: {
      heading: "Comment pouvons-nous vous aider ?",
      subtitle: "Sélectionnez tout ce qui vous intéresse — nous vous mettrons en relation avec le bon partenaire.",
      interestsLabel: "Je suis intéressé(e) par",
      messageLabel: "Quelque chose à ajouter ?",
      messagePlaceholder: "Ex. : je cherche un condo à Bangkok, une assurance santé pour deux…",
      submit: "Envoyer",
      needInterestTitle: "Choisissez au moins une option",
      needInterestDesc: "Dites-nous ce qui vous intéresse.",
    },
    interests: {
      real_estate: "Immobilier",
      insurance: "Assurance santé / voyage",
      other_visa: "Un autre visa",
      business_setup: "Création d'entreprise",
      relocation: "Aide à l'installation (écoles, banque…)",
      extraLabel: "Pouvons-nous vous aider pour autre chose en Thaïlande ?",
    },
    deleteAccount: {
      link: "Compte créé par erreur ? Supprimez-le",
      title: "Supprimer votre compte ?",
      desc: "Votre compte et les informations saisies seront définitivement supprimés. Cette action est irréversible.",
      confirm: "Supprimer mon compte",
      cancel: "Annuler",
      doneTitle: "Compte supprimé",
      doneDesc: "Votre compte a été supprimé. Vous serez toujours le bienvenu.",
      failedTitle: "Impossible de supprimer le compte",
      notEligible: "Ce compte est lié à une demande ou une adhésion. Envoyez-nous un message et nous le fermerons pour vous.",
    },
    done: {
      title: "Votre demande a bien été envoyée",
      desc: "Merci — notre équipe va l'examiner et vous contactera sous peu.",
      cta: "Accéder à mon tableau de bord",
    },
    optionalTag: "(facultatif)",
    memberOutcome: {
      linkedTitle: "Adhésion associée ✓",
      linkedDesc: "Bon retour — votre espace membre est prêt.",
      pendingTitle: "Presque terminé — confirmez votre adhésion",
      pendingDesc: "Nous avons envoyé une confirmation à votre e-mail enregistré ({{email}}). Une fois que vous aurez confirmé et que notre équipe aura validé, votre adhésion sera associée.",
    },
    banner: {
      memberTitle: "Merci — nous vérifions votre adhésion",
      memberDesc: "Notre équipe associera prochainement votre numéro de membre à ce compte. Vous serez notifié une fois confirmé.",
      prospectTitle: "Merci de nous avoir contactés",
      prospectDesc: "Un conseiller vous recontactera avec les informations demandées. Prêt à faire une demande ? Vous pouvez commencer à tout moment ci-dessous.",
      partnerTitle: "Merci de votre intérêt pour un partenariat",
      partnerDesc: "Prêt à collaborer avec nous ? Soumettez le profil de votre entreprise pour commencer — ou notre équipe partenariats vous contactera.",
      partnerCta: "Devenir partenaire",
      otherTitle: "Votre demande a bien été reçue",
      otherDesc: "Notre équipe va l'examiner et vous recontactera sous peu.",
    },
    toast: {
      saveFailedTitle: "Impossible d'enregistrer",
      saveFailedDesc: "Veuillez réessayer.",
      applicantOkTitle: "Parfait — commençons",
      applicantOkDesc: "Vous pouvez maintenant démarrer votre demande.",
      needMessageTitle: "Veuillez ajouter un court message",
      needMessageDesc: "Dites-nous comment nous pouvons vous aider.",
    },
  },
  common: {
    saveAndContinue: "Enregistrer et continuer",
    back: "Retour",
    submit: "Soumettre la demande",
    submitting: "Envoi en cours…",
    saving: "Enregistrement…",
    uploading: "Téléversement…",
    required: "Obligatoire",
    optional: "facultatif",
    yes: "Oui",
    no: "Non",
    select: "Sélectionner…",
    uploaded: "Téléversé",
    missing: "Manquant",
    loading: "Chargement…",
    download: "Télécharger",
    upload: "Téléverser",
    remove: "Supprimer",
    retry: "Réessayer",
    next: "Suivant",
    close: "Fermer",
    addDocuments: "Ajouter des documents",
    signOut: "Se déconnecter",
    memberPortal: "Espace membre",
    language: "Langue",
    // Toast messages
    fileTooLarge: "Fichier trop volumineux",
    maxSizeAllowed: "Maximum {{size}} autorisé.",
    uploadFailed: "Échec du téléversement",
    invalidEmail: "Email invalide",
  },

  dashboard: {
    myApplications: "Mes demandes",
    nextMemberApp: "Demande Membre Associé",
    addNextMember: "Ajouter un Membre Associé",
    nextMemberPromo: "Promotion : 750 000 THB par membre associé jusqu'au 31/12/2026",
    noApplications: "Aucune demande",
    noApplicationsDesc: "Commencez votre parcours Thailand Elite en créant votre première demande.",
    createApplication: "Créer une demande",
    newApplication: "Nouvelle demande",
    resumeApplication: "Reprendre la demande",
    alreadyActiveTitle: "Demande déjà en cours",
    alreadyActiveDesc: "Vous avez déjà une demande active. Veuillez la compléter ou l'annuler avant d'en créer une nouvelle.",
    package: "Programme",
    created: "Créée le",
    messages: "Messages",
    newThread: "Nouveau fil",
    newThreadSubject: "Objet",
    newThreadBody: "Message",
    generalInquiry: "Demande générale",
    noMessages: "Aucun message pour l'instant",
    status: {
      open: "Ouvert",
      waiting_reply: "En attente de réponse",
      closed: "Fermé",
      draft: "Brouillon",
      submitted: "Soumise",
      under_review: "En cours d'examen",
      background_check: "Vérification des antécédents",
      approved: "Approuvée",
      payment_pending: "Paiement en attente",
      payment_done: "En attente d'activation",
      active: "Active",
      cancelled: "Annulée",
      rejected: "Refusée",
    },
  },

  // ── Member Area ──────────────────────────────────────────────────────────
  membership: {
    card: {
      sectionTitle: "Votre carte de membre",
      tierLabel:    "Adhésion",
      holderLabel:  "Titulaire de la carte",
      numberLabel:  "Numéro de carte",
      validFrom:    "Valide du",
      validUntil:   "Valide jusqu'au",
      printOrSave:  "Imprimer ou enregistrer en PDF",
    },
    documents: {
      lettersTitle:                "Lettres officielles",
      welcomeLetter:               "Lettre de bienvenue",
      welcomeLetterDesc:           "Votre lettre de bienvenue officielle Thailand Elite",
      welcomeLetterPending:        "Sera téléversée par votre agent dès la confirmation de l'activation",
      certificationLetter:        "Lettre de certification",
      certificationLetterDesc:    "Document de certification officiel Thailand Privilege",
      certificationLetterPending: "Disponible dès son émission par Thailand Privilege",
      pending:                    "En attente",
    },
  },

  // ── Member Services / Service Requests ───────────────────────────────────
  services: {
    tabLabel:           "Services",
    title:              "Services aux membres",
    intro:              "Soumettez une demande de service — apposition du visa, notification de 90 jours ou toute autre demande. Votre numéro de membre est joint automatiquement.",
    chooseType:         "Choisir un service",
    noTypes:            "Aucun type de service disponible pour le moment. Veuillez contacter le support.",
    estimated:          "~{{days}} jours ouvrés",
    history:            "Vos demandes précédentes",
    back:               "Retour aux services",
    requirementsTitle:  "Ce que vous devez fournir",
    memberIdLabel:      "Soumis en tant que",
    subject:            "Objet",
    messageLabel:       "Décrivez votre demande",
    messagePlaceholder: "Ajoutez tout détail qui nous aidera à traiter votre demande plus rapidement.",
    attachments:        "Pièces jointes",
    addFile:            "Cliquez pour téléverser (PDF / JPG / PNG, max 10 Mo)",
    send:               "Envoyer la demande",
    submittedTitle:     "Demande soumise",
    submittedDesc:      "Notre équipe Services aux membres l'examinera et vous répondra via la messagerie.",
    submittedDescMcc:      "Notre équipe va l'examiner et vous répondra via Messages. Pour un traitement plus rapide, envoyez l'e-mail prêt à l'emploi au MCC ci-dessous.",
    mcc: {
      title: "Contacter directement le MCC",
      intro: "Le Member Contact Center (MCC) de Thailand Privilege réserve ce service. Envoyez-lui cet e-mail déjà rédigé en anglais depuis votre propre messagerie : nous en recevons une copie et assurons le suivi pour vous.",
      titleNext: "Accélérez votre demande : écrivez au MCC",
      recommended: "Recommandé · traitement plus rapide",
      oneMinute: "Cela prend une minute : l'e-mail est prêt, il suffit de l'envoyer.",
      attachReminder: "Vos documents ne sont pas ajoutés automatiquement (confidentialité). Joignez-les à votre e-mail : {{files}}",
      linksIncluded: "Vos documents sont inclus dans l'e-mail sous forme de liens sécurisés (valables jusqu'au {{date}}). Vous pouvez aussi les joindre.",
      copyTip: "Astuce : utilisez « Copier l'e-mail » puis collez-le dans votre messagerie, les noms des fichiers deviennent des liens cliquables.",
      emailButton: "Écrire au MCC",
      gmailButton: "Ouvrir dans Gmail",
      callButton: "Appeler le MCC",
      copyButton: "Copier l'e-mail",
      copied: "E-mail copié.",
      preview: "Voir l'e-mail",
      hidePreview: "Masquer l'e-mail",
      confirmEmailTitle: "Avez-vous envoyé votre e-mail au MCC ?",
      confirmPhoneTitle: "Avez-vous pu joindre le MCC ?",
      confirmHint: "Le MCC répond généralement en quelques heures. Pour une demande urgente, envoyez l'e-mail et appelez aussi le {{phone}}.",
      yes: "Oui",
      notYet: "Pas encore",
      statusEmail: "Vous avez écrit au MCC le {{date}}.",
      statusPhone: "Vous avez appelé le MCC le {{date}}.",
      copyReceived: "Nous avons bien reçu la copie de votre e-mail.",
      followupTitle: "Avez-vous obtenu une réponse du MCC ?",
      answered: "Oui, c'est réglé",
      needHelp: "Non, j'ai besoin d'aide",
      thanks: "Merci, c'est noté.",
      helpSent: "Nous nous en occupons : notre équipe relance le MCC pour vous.",
      packageTitle: "Votre adhésion : {{package}}",
      privilegePoints: "Points Privilège",
      privilegeBook: "Privilege Book 2026 (PDF)",
      mccLine: "Member Contact Center : {{email}} · {{phone}}",
      done: "Terminé",
    },
    details: {
      whereTitle: "Où souhaitez-vous faire apposer votre visa ?",
      airport: "À l'aéroport, à l'arrivée",
      airportHint: "Arrivée au moins 7 jours après aujourd'hui. Préparez votre billet d'avion.",
      chaeng: "À l'Immigration de Chaeng Watthana, Bangkok",
      chaengHint: "Un jour ouvré, au moins 5 jours ouvrés après aujourd'hui. Une copie du TM30 est requise.",
      arrivalAirport: "Aéroport d'arrivée",
      flightNumber: "Numéro de vol",
      departureFrom: "Au départ de",
      departurePlaceholder: "ex. Paris CDG",
      arrivalDate: "Date d'arrivée",
      arrivalTime: "Heure d'arrivée (locale)",
      ticket: "Billet d'avion ou itinéraire",
      ticketHint: "PDF ou photo. Nous vérifions qu'il correspond au vol ci-dessus.",
      ticketChecking: "Vérification du billet…",
      ticketMatch: "Billet vérifié : le vol et la date correspondent.",
      ticketMismatch: "Veuillez vérifier votre billet :",
      ticketUnreadable: "Nous n'avons pas pu lire le billet automatiquement. Notre équipe le vérifiera.",
      preferredDate: "Date souhaitée",
      period: "Moment de la journée",
      morning: "Matin (9h00–12h00)",
      afternoon: "Après-midi (13h00–16h00)",
      alternativeDate: "Deuxième choix (facultatif)",
      tentative: "Les dates sont indicatives et confirmées par Member Services, selon les disponibilités.",
      tm30: "Copie du TM30 (justificatif d'adresse)",
      tm30Hint: "Le reçu TM30 de votre propriétaire ou de votre hôtel.",
      passportCopy: "Copie du passeport (page photo)",
      passportHint: "Le passeport dans lequel le visa sera apposé. Si vous avez un nouveau passeport, téléversez-le à la place.",
      passportFromApplication: "Issu de votre demande d'adhésion",
      useApplicationPassport: "Utiliser le passeport de ma demande d'adhésion",
      passportNewWarning: "Ce n'est pas le passeport utilisé pour votre demande d'adhésion. Avec un nouveau passeport, l'Immigration peut devoir refaire la vérification des antécédents avant d'apposer le visa, ce qui peut prendre plus de temps. Nous vous dirons si autre chose est nécessaire.",
      tm30Guide: "Qu'est-ce que le TM30 ?",
      upload: "Téléverser",
      replace: "Remplacer",
      bank: "Banque",
      bankPlaceholder: "Choisir une banque",
      city: "Ville",
      branch: "Agence (facultatif)",
      branchPlaceholder: "ex. Silom, Central World",
      bankHint: "La banque décide en dernier ressort et peut demander d'autres documents.",
      ninetyTitle: "À propos de la déclaration de 90 jours",
      ninetySummary: "Le formulaire TM47 confirme votre adresse tous les 90 jours de séjour continu. Quitter la Thaïlande remet le compteur à zéro. La déclaration peut être faite de 15 jours avant à 7 jours après l'échéance ; un retard est sanctionné d'une amende de 2 000 THB.",
      readGuide: "Lire le guide complet",
      messageOptional: "Autre chose à nous signaler ?",
      noMessage: "Voir les détails ci-dessous.",
      licenseType: "Type de permis",
      car: "Voiture",
      motorcycle: "Moto",
      both: "Voiture et moto",
      office: "Bureau du Department of Land Transport",
      chatuchak: "Chatuchak, Bangkok",
      otherOffice: "Autre bureau",
      otherOfficePlaceholder: "Ville / bureau",
      homeLicense: "Votre permis de conduire national en cours de validité",
      residenceCertificate: "Certificat de résidence",
      residenceCertificateHint: "Délivré par votre ambassade (ou un permis de travail).",
      medicalCertificate: "Certificat médical",
      medicalCertificateHint: "D'une clinique en Thaïlande, daté de moins d'un mois. Il peut aussi être obtenu avant le rendez-vous.",
      drivingIntro: "Réalisé en une journée au Department of Land Transport avec notre accompagnateur. Apportez votre passeport avec le visa Privilege.",
      drivingGuide: "Guide du permis de conduire",
      epaService: "Service",
      epaArrival: "Arrivée",
      epaDeparture: "Départ",
      epaAirport: "Aéroport",
      flightDate: "Date du vol",
      flightTime: "Heure du vol (locale)",
      originCity: "Ville de provenance",
      originCityPlaceholder: "ex. Paris",
      passengers: "Nombre de passagers",
      epaHint: "L'EPA fonctionne de 6h00 à 24h00. Réservez au moins 5 heures avant votre vol.",
      optional: "facultatif",
      docType: "Type de document",
      docTypes: {
        passport: "Passeport",
        visa_page: "Page du visa",
        photo: "Photo",
        entry_stamp: "Tampon d'entrée",
        tm30: "TM30",
        flight_ticket: "Billet d'avion",
        home_license: "Permis de conduire (pays d'origine)",
        residence_certificate: "Certificat de résidence",
        medical_certificate: "Certificat médical",
        other: "Autre document",
      },
      phone: "Numéro de téléphone (pour le MCC)",
      phoneHint: "Repris de votre profil. Vous pouvez le modifier.",
      fromApplication: "Ajouter depuis ma demande d'adhésion",
      fromApplicationHint: "Documents déjà envoyés avec votre demande d'adhésion. Inutile de les téléverser à nouveau.",
      appDocs: {
        passport_photo: "Page photo du passeport",
        passport_signature: "Page signature du passeport",
        visa: "Page du visa",
        arrival_stamp: "Tampon d'entrée",
        profile_photo: "Photo",
        marriage_certificate: "Acte de mariage",
        birth_certificate: "Acte de naissance",
      },
      errors: {
        licenseTypeRequired: "Choisissez le type de permis.",
        officeRequired: "Choisissez le bureau.",
        homeLicenseRequired: "Téléversez votre permis de conduire national.",
        residenceCertificateRequired: "Téléversez votre certificat de résidence.",
        epaServiceRequired: "Choisissez arrivée ou départ.",
        flightDateRequired: "Saisissez la date du vol.",
        flightDatePast: "La date du vol est passée.",
        flightTimeRequired: "Saisissez l'heure du vol.",
        epaTooSoon: "L'EPA doit être réservé au moins 5 heures avant le vol.",
        originCityRequired: "Saisissez la ville de provenance.",
        locationRequired: "Choisissez où apposer le visa.",
        airportRequired: "Choisissez l'aéroport d'arrivée.",
        flightNumberInvalid: "Saisissez le numéro de vol, ex. TG931.",
        arrivalDateRequired: "Saisissez la date d'arrivée.",
        arrivalTooSoon: "L'arrivée doit être le {{date}} ou plus tard (7 jours après aujourd'hui).",
        arrivalTimeRequired: "Saisissez l'heure d'arrivée.",
        preferredDateRequired: "Choisissez une date souhaitée.",
        weekend: "L'Immigration est fermée le week-end. Choisissez du lundi au vendredi.",
        appointmentTooSoon: "Choisissez le {{date}} ou plus tard (5 jours ouvrés après aujourd'hui).",
        periodRequired: "Choisissez le matin ou l'après-midi.",
        alternativeInvalid: "Le deuxième choix doit être un jour ouvré, le {{date}} ou plus tard.",
        tm30Required: "Téléversez une copie de votre TM30.",
        passportRequired: "Joignez une copie de votre passeport.",
        bankRequired: "Choisissez une banque.",
        cityRequired: "Choisissez une ville.",
      },
    },
  },

  wizard: {
    applicationSteps: "Étapes de la demande",
    step: "Étape",
    of: "sur",
    readOnlyBanner: "Cette demande a été soumise. Contactez le support pour demander des modifications.",
    readOnlySupportLink: "Demander une modification",
    backgroundCheckTitle: "Demande en cours d'examen",
    backgroundCheckBody: "Votre demande est actuellement en cours d'examen par notre équipe et les autorités thaïlandaises compétentes. À ce stade, votre demande ne peut pas être annulée ou modifiée. Pour toute question, contactez notre équipe de support.",
    backgroundCheckExpected: "Vous pouvez recevoir votre lettre d'approbation approximativement le :",
    backgroundCheckNote: "* Il s'agit d'un délai estimé basé sur un traitement habituel de 4 à 8 semaines. Il n'est pas garanti.",
    backgroundCheckContact: "Pour toute question, contactez notre équipe :",
    steps: {
      package: "Programme",
      passport: "Passeport",
      personalInfo: "Informations personnelles",
      address: "Adresse",
      visa: "Visa & Entrée",
      documents: "Documents",
      review: "Vérification",
    },
    stepDescriptions: {
      package: "Sélectionnez votre programme d'adhésion Thailand Elite",
      passport: "Téléversez et vérifiez votre passeport",
      personalInfo: "Complétez vos informations personnelles",
      address: "Votre adresse de résidence et coordonnées",
      visa: "Statut visa et entrée actuels",
      documents: "Téléversez et signez les documents requis",
      review: "Vérifiez et soumettez votre demande",
    },
  },

  nextMember: {
    title: "Demande Membre Suivant",
    subtitle: "Vous postulez en tant que membre suivant sous un abonnement principal existant.",
    badge: "Membre Suivant",
    addButton: "Ajouter un membre suivant",
    relationship: "Relation avec le membre principal",
    selectRelationship: "Sélectionnez la relation…",
    relationships: {
      spouse: "Conjoint(e)",
      child: "Enfant",
      parent: "Parent",
      adopted_child: "Enfant adopté(e)",
      civil_union: "Partenaire de PACS",
    },
    coreApplication: "Demande principale",
    additionalFee: "Frais membre supplémentaire",
    promoLabel: "Tarif promotionnel",
    regularFee: "Tarif normal",
    promoUntil: "Valable jusqu'au 31/12/2026",
    perMember: "/membre",
    existingNextMember: "Demande membre suivant",
  },

  package: {
    title: "Choisir votre programme",
    subtitle: "Sélectionnez le programme d'adhésion Thailand Elite qui vous convient le mieux.",
    selected: "Sélectionné",
    selectPackage: "Choisir ce programme",
    years: "ans",
    perYear: "par an",
    includes: "Inclus",
    familyOption: "Option famille disponible",
  },

  passport: {
    title: "Vérification du passeport",
    subtitle: "Téléversez la page d'identité de votre passeport pour la vérification OCR.",
    uploadTitle: "Téléverser la photo du passeport",
    uploadDesc: "Photo ou scan de la page d'identité du passeport (JPG, PNG, PDF — max 10 Mo)",
    uploadHint: "Appuyez pour téléverser ou prendre une photo",
    extractTitle: "Extraire les données",
    extractDesc: "Cliquez pour remplir vos informations automatiquement par IA — cela prend quelques secondes",
    retakePhoto: "Reprendre / Re-téléverser",
    passportNumber: "Numéro de passeport",
    surname: "Nom",
    givenName: "Prénom(s)",
    nationality: "Nationalité",
    dateOfBirth: "Date de naissance",
    sex: "Sexe",
    dateOfIssue: "Date de délivrance",
    dateOfExpiry: "Date d'expiration",
    placeOfBirth: "Lieu de naissance",
    mrz: "Zone de lecture automatique (MRZ)",
    extractedData: "Données extraites",
    verifyAndContinue: "Vérifier et continuer",
    lowConfidenceWarning: "Certains champs n'ont pas pu être lus clairement. Veuillez vérifier avant de continuer.",
    expiryWarning: "Votre passeport doit être valide au moins 6 mois pour postuler.",
    expiryModalTitle: "Problème de validité du passeport",
    expiryModalDesc: "La validité de votre passeport doit être supérieure à 1 an à compter de la date de soumission. Veuillez renouveler votre passeport avant de postuler.",
    expiryModalCta: "J'ai compris",
    // Scan requirements
    scanRequirements: "Exigences de numérisation",
    scanReqColor: "Scan couleur — pas de noir et blanc",
    scanReqEdges: "Les quatre bords visibles",
    scanReqResolution: "Haute résolution, tout le texte lisible",
    scanReqFocus: "Pas flou ou hors focus",
    gallery: "Galerie",
    scanning: "Numérisation…",
    uploadDifferentFile: "Téléverser un autre fichier",
    fileFormatHint: "JPG, PNG ou PDF · max 10 Mo",
    // Gender options
    male: "Homme",
    female: "Femme",
    // Placeholders
    cityOrTown: "Ville",
    country: "Pays",
    asShownOnPassport: "Tel qu'indiqué sur le passeport",
    ifApplicable: "Si applicable",
    // Toast messages
    passportUploaded: "Passeport téléversé",
    passportUploadedDesc: "Cliquez sur \" Scanner avec l'IA \" pour extraire vos données.",
    passportScanned: "Passeport scanné ✓",
    passportScannedDesc: "Vérifiez les données extraites ci-dessous.",
    qualityIssuesDetected: "Problèmes de qualité détectés",
    scanUnavailable: "Scan indisponible",
    scanUnavailableDesc: "Veuillez remplir vos informations manuellement ci-dessous.",
    applicationAlreadyExists: "Demande déjà existante",
    applicationAlreadyExistsDesc: "Une demande pour {{name}} a déjà été commencée. Veuillez la reprendre ou contacter le support.",
    // OCR quality issues
    blurryImage: "Image floue",
    reflectionDetected: "Reflet / éblouissement détecté",
    glareOnPassport: "Reflet sur le passeport",
    imageCropped: "Image coupée — re-scannez le passeport en entier",
    bioPageComplete: "Page biographique complète",
    mrzReadable: "MRZ lisible",
    // Signature section
    signaturePage: "Page de signature",
    signatureOptional: "Facultatif",
    signaturePageRequired: "Téléversez la page de votre passeport contenant votre signature manuscrite si elle ne figure pas sur votre page biographique.",
    signatureDetectedOnBio: "Votre signature a été détectée sur la page biographique. Vous pouvez également téléverser la page de signature séparée si votre passeport en possède une.",
    signatureDetectedConfirm: "Signature détectée sur la page biographique ✓",
    signatureDetectedNote: "Si votre passeport a également une page de signature dédiée (courant dans les passeports français, italiens, allemands), vous pouvez la téléverser ci-dessous.",
    signatureNotCorrect: "Incorrect — pas de signature sur cette page",
    noSignatureOnBioPage: "Aucune signature trouvée sur la page biographique",
    noSignatureOnBioPageNote: "Certains passeports n'incluent pas de signature sur la page biographique — veuillez téléverser la page contenant votre signature. Ceci est requis pour les passeports de : <strong>Singapour, Philippines, Malaisie, Indonésie, Suède, EAU, Arabie Saoudite, Qatar, Koweït, Bahreïn, Oman</strong>, et la plupart des passeports d'enfants.",
    signaturePageUploaded: "Page de signature téléversée",
    uploadSignaturePageOptional: "Téléverser la page de signature (Facultatif)",
    uploadSignaturePage: "Téléverser la page de signature",
    replace: "Remplacer",
    pdf: {
      label: "PDF du passeport",
      openPreview: "Ouvrir l'aperçu PDF",
      detectedNote: "PDF détecté — la page du passeport est lue directement dans le PDF.",
    },
    ocrCooldown: "Veuillez patienter quelques secondes avant de réessayer.",
  },

  personalInfo: {
    title: "Informations personnelles",
    subtitle: "Vérifiez et complétez votre profil et les détails de votre demande.",
    profilePhoto: {
      title: "Photo d'identité",
      desc: "Une photo récente et nette de votre visage (style passeport). Requise pour votre carte de membre.",
      uploadButton: "Téléverser une photo",
      changeButton: "Changer de photo",
      takePhoto: "Prendre une photo",
      saved: "Enregistré",
      photoSaved: "Photo enregistrée ✓",
      photoUploadFailed: "Échec du téléversement de la photo",
      removeBackgroundAi: "Supprimer le fond avec l'IA",
      removeBackgroundNote: "Le fond sera remplacé par du blanc — appliqué au prochain téléversement.",
    },
    identity: {
      sectionTitle: "Identité",
      title: "Titre",
      givenName: "Prénom",
      middleName: "Deuxième prénom",
      surname: "Nom de famille",
      nameOnCard: "Nom sur la carte Elite",
      nameOnCardHint: "Nom qui apparaîtra sur votre carte de membre",
      dateOfBirth: "Date de naissance",
      gender: "Sexe / Genre",
      occupation: "Profession",
      businessIndustry: "Secteur d'activité",
    },
    applicationDetails: {
      sectionTitle: "Détails de la demande",
      sectionDesc: "Prérempli à partir de votre scan de passeport. Les données du passeport sont automatiquement prioritaires.",
      fromPassport: "Depuis le passeport",
      nationality: "Nationalité",
      placeOfBirth: "Lieu de naissance",
      countryOfBirth: "Pays de naissance",
    },
    nationalityCheck: {
      question: "Possédez-vous actuellement une autre nationalité ou citoyenneté ?",
      otherNationality: "Autre nationalité",
      passportsIntro: "Déclarez chaque autre passeport et nationalité que vous détenez. Ces informations figurent sur la déclaration de passeports et nationalités multiples (page 2 de votre formulaire de candidature), que vous signerez.",
      passportHeading: "Autre passeport {{n}}",
      passportNumber: "Numéro de passeport",
      issueDate: "Date de délivrance",
      expiryDate: "Date d'expiration",
      nameOnPassport: "Nom complet sur ce passeport (s'il diffère)",
      addPassport: "Ajouter un autre passeport",
      passportRequired: "Veuillez indiquer la nationalité et le numéro de votre autre passeport.",
      requiredDocsTitle: "Documents requis pour les candidats ayant plusieurs nationalités :",
      reqDoc1: "Le(s) passeport(s) de votre nationalité d'origine, ainsi que tout ancien passeport si votre nom ou prénom a changé.",
      reqDoc2: "Le(s) document(s) officiel(s) attestant la renonciation à votre nationalité d'origine (le cas échéant).",
      reqDoc3: "Des justificatifs de revenus et de l'origine des fonds utilisés pour l'adhésion.",
      reqDoc4: "Un justificatif de résidence permanente en Thaïlande ou à l'étranger couvrant les 6 derniers mois.",
      mismatchTitle: "Votre pays de naissance diffère de votre nationalité",
      mismatchIntro: "Nous avons également constaté que votre pays de naissance est différent de votre pays de citoyenneté, alors que vous avez indiqué ne détenir qu'une seule nationalité.",
      mismatchBody: "Veuillez noter que les autorités de l'Immigration appliquent des exigences strictes pour l'apposition du visa et peuvent demander des documents complémentaires. Si vous avez une double nationalité, vous devez la déclarer. Si vous avez renoncé à une nationalité antérieure, veuillez préparer les justificatifs correspondants.",
      listTitle: "Le cas échéant, veuillez fournir :",
      doc1: "Une copie lisible de votre second passeport.",
      doc2: "Une copie de votre certificat de nationalité ou de tout autre document montrant comment vous avez obtenu votre nationalité actuelle, accompagnée d'une brève explication.",
      doc3: "Une copie de votre certificat de renonciation si vous déteniez auparavant une autre nationalité à laquelle vous avez renoncé.",
      explanationLabel: "Brève explication (facultatif)",
      explanationPlaceholder: "ex. Né au Brésil, naturalisé français en 2010, nationalité brésilienne abandonnée en 2012.",
      uploadTitle: "Justificatifs",
      uploadDesc: "PDF, JPG ou PNG — 10 Mo max. par fichier.",
    },
    contact: {
      phone: "Téléphone",
      phonePlaceholder: "+66 XX XXX XXXX",
      email: "Adresse e-mail",
      emailHint: "Utilisée pour votre demande. Peut différer de votre e-mail de connexion.",
    },
    sharedProfile: "Profil partagé",
    fillAllRequiredFields: "Veuillez remplir tous les champs obligatoires",
  },

  address: {
    title: "Adresse",
    subtitle: "Votre adresse de résidence actuelle.",
    currentAddress: "Adresse actuelle",
    street: "Adresse",
    streetHint: "Autocomplétion OpenStreetMap",
    startTyping: "Commencez à taper votre adresse…",
    city: "Ville",
    state: "État / Province",
    country: "Pays",
    postalCode: "Code postal",
    thaiAddress: "Adresse en Thaïlande",
    haveThaiAddress: "J'ai une adresse en Thaïlande",
    accommodationType: "Type de logement",
    province: "Province",
    district: "District",
    subDistrict: "Sous-district",
    thaiTelephone: "Téléphone (Thaïlande)",
    thaiPhoneNote: "Numéro thaïlandais (sans le 0 initial)",
    validationError: "Veuillez renseigner la rue, la ville et le pays",
  },

  visa: {
    title: "Statut visa & entrée",
    subtitle: "Votre visa thaïlandais actuel et informations d'entrée.",
    currentVisa: "Visa thaïlandais actuel",
    hasThaiVisa: "Êtes-vous actuellement titulaire d'un visa thaïlandais ?",
    visaType: "Type de visa",
    visaExpiry: "Date d'expiration du visa",
    uploadVisaPage: "Photo de la page visa",
    uploadVisaBtn: "Téléverser la page visa",
    arrivalStamp: "Tampon d'arrivée",
    hasArrivalStamp: "Êtes-vous actuellement titulaire d'un tampon d'arrivée ?",
    stampExpiry: "Date d'expiration du tampon",
    uploadStampPage: "Photo de la page tampon",
    uploadStampBtn: "Téléverser la page tampon",
    passportStatus: "État du passeport",
    blankVisaPages: "Plus de 3 pages vierges pour visas dans votre passeport ?",
    blankYes: "Oui — plus de 3",
    blankNo: "Non — 3 ou moins",
    overstayCount: "Séjours irréguliers en Thaïlande (3 dernières années)",
    overstayNever: "0 — Jamais",
    otherVisaOption: "Autre (préciser)",
    otherVisaLabel: "Précisez votre visa",
    otherVisaPlaceholder: "Code court, ex. Non-O, SMART-T",
    edVisa: {
      sectionTitle: "Historique visa Éducation (ED)",
      sectionDesc: "Déclaration requise pour l'évaluation d'éligibilité Thailand Elite.",
      question: "Avez-vous un historique de visa Éducation (ED) au cours des 5 dernières années ou dans votre passeport actuel ?",
      warningTitle: "Documents justificatifs supplémentaires requis",
      warningDesc: "L'acceptation des candidats ayant des antécédents de visa Éducation est soumise à la soumission des documents suivants. L'absence de documents peut entraîner un refus.",
      doc1: "Licence d'établissement scolaire (สช.2 / OBEC / OPEC)",
      doc2: "Enregistrement scolaire (ร.2)",
      doc3: "Certificat de scolarité délivré par l'école",
      doc4: "Relevés de notes, bulletins scolaires et registre de présences",
      doc5: "Photos d'activités de classe",
      doc5Optional: "(facultatif — à téléverser ultérieurement si non disponible)",
      acknowledgementForm: "Formulaire de reconnaissance",
      acknowledgementFormDesc: "Télécharger, remplir et téléverser avec vos documents justificatifs",
      uploadTitle: "Téléverser les documents justificatifs",
      uploadDesc: "PDF, JPG ou PNG — vous pouvez téléverser plusieurs fichiers. Sauvegardés en toute sécurité dans votre dossier.",
    },
  },

  visaReminder: {
    title: "Important — Maintenez un visa valide",
    body: "Veuillez maintenir un visa valide à tout moment si vous êtes en Thaïlande. La soumission de cette demande ne vous accorde aucune extension de séjour ni permission de rester en Thaïlande. Si vous êtes actuellement en Thaïlande, assurez-vous que votre visa reste valide tout au long du processus.",
  },

  documents: {
    title: "Documents",
    subtitle: "Téléchargez, signez et téléversez vos formulaires de demande.",
    applicationForm: {
      title: "Formulaire de demande",
      desc: "Téléchargez votre formulaire prérempli, signez-le numériquement, puis téléversez-le.",
      download: "Télécharger le PDF prérempli",
      signDigitally: "Signer numériquement",
      signatureCapture: "Capturer la signature",
      signatureCaptureDesc: "Dessinez votre signature ci-dessous",
      clear: "Effacer",
      save: "Enregistrer la signature",
      appliedTo: "Appliqué à toutes les pages",
      uploadSigned: "Téléverser le formulaire signé",
    },
    pdpaForm: {
      title: "Formulaire de consentement PDPA",
      desc: "Consentement à la loi sur la protection des données personnelles. À télécharger, signer et téléverser.",
      download: "Télécharger le formulaire PDPA",
      signDigitally: "Signer numériquement",
      uploadSigned: "Téléverser le formulaire signé",
    },
    uploadStatus: "Statut des téléversements",
    viewDocument: "Voir le document téléversé",
    downloadDocument: "Télécharger le PDF signé",
    signingComplete: "Signature terminée — téléversez pour enregistrer",
    remaining: "restant(s)",
    requiredDocuments: "Documents requis",
    continueToReview: "Continuer vers la révision",
    blankForm: "Formulaire vierge",
    blankAddendum: "Avenant promotionnel vierge",
    downloadLabel: "Télécharger",
    reprefill: "Re-remplir",
    // Toast messages for DocumentsStep
    applicationFormPrefilled: "Formulaire de demande prérempli",
    applicationFormPrefilledDesc: "Téléchargé ! Signez chaque page, puis téléversez ou signez numériquement.",
    prefillFailed: "Échec du préremplissage",
    applicationFormSigned: "Formulaire de demande signé et enregistré ✓",
    signingFailed: "Échec de la signature",
    applicationFormUploaded: "Formulaire de demande téléversé ✓",
    pdpaFormSigned: "Formulaire PDPA signé et enregistré ✓",
    pdpaFormUploaded: "Formulaire PDPA téléversé ✓",
    documentUploaded: "Document téléversé ✓",
    uploaded: "Téléversé ✓",
    translationUploaded: "Traduction téléversée ✓",
    uploadTranslation: "Téléverser la traduction",
    relationshipProof: {
      title: "Documents de preuve de relation",
      subtitle: "Téléversez les documents officiels prouvant votre relation avec le membre principal.",
      marriageCert: "Certificat de mariage",
      birthCert: "Acte de naissance",
      adoptionCert: "Certificat d'adoption",
      civilUnionCert: "Certificat de PACS",
      notInEnglish: "Ce document n'est pas en anglais",
      certifiedTranslation: "Traduction certifiée en anglais",
    },
    signatureCapture: {
      title: "Signature électronique (facultatif)",
      subtitle: "Dessinez ou téléversez votre signature pour l'appliquer à tous vos documents.",
      saved: "Signature enregistrée",
      willBeApplied: "Sera appliquée à tous les documents",
      confirm: "Je comprends et souhaite signer numériquement",
      disclaimer1: "Le demandeur doit signer personnellement toutes les pages de la demande. Si le demandeur a moins de 20 ans, le représentant légal doit également signer.",
      disclaimer2: "Toutes les signatures doivent correspondre exactement à la signature figurant sur le passeport.",
      disclaimer3: "⚠️ Nous acceptons les signatures numériques, mais veuillez noter que dans certains cas, Thailand Privilege Card peut demander une copie entièrement imprimée, signée à la main et scannée de toutes les pages. Si vous disposez d'une imprimante et d'un scanner, nous recommandons fortement l'impression et la signature manuscrite.",
      options: {
        upload: {
          title: "Téléverser la signature",
          desc: "Téléversez une image de votre signature",
          instruction: "Cliquez ou déposez un fichier image ici",
          enhancing: "Amélioration…",
          clickToUpload: "Cliquez pour téléverser",
        },
        passport: {
          title: "Utiliser la signature du passeport",
          desc: "Extraire votre signature du scan de passeport téléversé",
          passportRef: "Scan du passeport",
          notFound: "Aucun scan de passeport trouvé — veuillez d'abord téléverser votre passeport",
          instruction: "Cliquez pour extraire la signature du passeport",
          uploadBtn: "Extraire du passeport",
        },
        draw: {
          title: "Dessiner la signature",
          desc: "Dessinez votre signature avec la souris ou le doigt",
        },
      },
    },
  },

  review: {
    title: "Vérification & soumission",
    subtitle: "Vérifiez votre demande avant de la soumettre.",
    applicationSummary: "Résumé de la demande",
    membershipPackage: "Programme d'adhésion",
    fullName: "Nom complet",
    nationality: "Nationalité",
    dateOfBirth: "Date de naissance",
    passportNo: "N° de passeport",
    passportExpiry: "Expiration du passeport",
    occupation: "Profession",
    country: "Pays",
    city: "Ville",
    phone: "Téléphone",
    email: "E-mail",
    remaining: "restant(s)",
    requiredDocuments: "Documents requis",
    passportPhoto: "Photo passeport / pièce d'identité",
    profilePhoto: "Photo de profil",
    applicationFormSigned: "Formulaire de demande (signé)",
    pdpaFormSigned: "Formulaire PDPA (signé)",
    missingDocsWarning: "Veuillez compléter tous les documents requis à l'étape 6 avant de soumettre.",
    // Validation issues
    validation: {
      fullNameMissing: "Nom complet manquant",
      passportNoMissing: "Numéro de passeport manquant",
      passportExpiryMissing: "Date d'expiration du passeport manquante",
      passportValidityWarning: "La validité du passeport doit être supérieure à 1 an à compter de la date de demande",
      nationalityMissing: "Nationalité manquante",
      otherNationalityMissing: "Question sur la seconde nationalité sans réponse",
      phoneMissing: "Numéro de téléphone manquant",
      countryMissing: "Pays de résidence manquant",
      cityMissing: "Ville manquante",
      missingInfoTitle: "Informations manquantes — veuillez compléter avant de soumettre",
      goTo: "Aller à",
      completeBeforeSubmitting: "Veuillez compléter les informations manquantes ci-dessus avant de soumettre",
      accountFlaggedTitle: "Votre compte a été signalé",
      uploadFlagged: "L'un de vos fichiers ne respecte pas nos règles relatives aux documents ; votre compte a donc été signalé pour vérification. S'il s'agit d'une erreur, envoyez-nous un message et notre équipe vérifiera.",
      contactUs: "Nous envoyer un message",
      passportNotGenuine: "Le fichier envoyé n'est pas une page d'identité de passeport lisible (la page avec votre photo et les deux lignes de code en bas). Veuillez envoyer une copie nette de votre vrai passeport.",
      passportDataMismatch: "Certaines informations ne correspondent pas à votre passeport scanné : {{fields}}. Veuillez les corriger pour qu'elles correspondent exactement à votre passeport.",
      mismatchConfirm: "Mes informations sont correctes — merci de faire vérifier mon passeport par l'équipe",
      fieldPassportNo: "numéro de passeport",
      fieldDob: "date de naissance",
      fieldExpiry: "date d'expiration du passeport",
    },
    survey: {
      title: "Sondage",
      howDidYouLearn: "Comment avez-vous découvert Thailand Elite ?",
      mainReason: "Principale raison de votre demande ?",
      expectation: "Qu'attendez-vous de l'adhésion ?",
    },
    agreement: "Je confirme que toutes les informations fournies sont exactes, complètes et authentiques. Je consens au traitement de mes données personnelles et documents — y compris la reconnaissance OCR du passeport et la vérification de signature assistées par IA — par Dreamond et Thailand Privilege Card Co., Ltd. aux fins de ma demande d'adhésion. Je comprends qu'aucun paiement n'est requis avant l'approbation officielle de ma demande, et que tout paiement doit être effectué exclusivement auprès de Thailand Privilege Card Co., Ltd. sur la base de leur facture officielle. J'ai lu et j'accepte les",
    termsAndConditions: "Conditions générales",
    and: "et la",
    privacyPolicy: "Politique de confidentialité",
    noPaymentNote: "aucun paiement n'est requis avant l'approbation officielle",
    missingDocumentsError: "Documents manquants",
    missingDocumentsErrorDesc: "Veuillez téléverser tous les documents requis avant de soumettre.",
    submittedTitle: "Demande soumise !",
    submittedDesc: "Nous examinerons votre demande et vous répondrons dans les meilleurs délais.",
    submissionFailed: "Échec de la soumission",
  },

  // ── Écrans post-approbation ───────────────────────────────────────────────
  screens: {
    common: {
      contactSupport: "Pour toute question, contactez notre équipe :",
    },
    approved: {
      title: "Félicitations ! Votre demande a été approuvée",
      message: "Veuillez consulter vos e-mails pour la lettre d'approbation et la facture. Vous devez effectuer le paiement dans les 30 jours pour activer votre adhésion.",
      uploadTitle: "Téléverser la preuve de paiement",
      uploadHint: "Reçu de virement, capture d'écran ou PDF (max 10 Mo)",
      uploadButton: "Téléverser la preuve",
      uploadSuccess: "Preuve de paiement téléversée",
      uploadSuccessDesc: "Le service financier vérifiera votre paiement, généralement sous 3 jours ouvrés environ.",
      uploadedConfirmation: "Preuve de paiement téléversée — en cours de vérification",
      cardPaymentTitle: "Payer par carte bancaire",
      cardPaymentHint: "Demandez un lien de paiement sécurisé au service financier",
      requestLink: "Demander un lien de paiement",
      payByCard: "Payer par carte",
      linkRequested: "Demande envoyée",
      linkRequestedDesc: "Le service financier vous enverra un lien de paiement prochainement.",
      note: "Si vous avez déjà téléversé votre preuve de paiement, aucune action supplémentaire n'est requise.",
      proofRejectedTitle: "Nous n'avons pas pu valider votre preuve de paiement",
      proofRejectedHelp: "Veuillez téléverser une nouvelle preuve de paiement ci-dessous. Pour toute question, répondez à notre e-mail ou contactez-nous.",
    },
    paymentPending: {
      title: "Paiement en cours de vérification",
      message: "Votre preuve de paiement a bien été reçue et transmise au service financier pour vérification. La vérification prend généralement environ 3 jours ouvrés, puis environ 4 jours ouvrés pour l'activation de votre adhésion et la lettre de bienvenue.",
      verifying: "Vérification en cours…",
      uploaded: "Téléversé",
      expected: "Vérification attendue",
      uploadDate: "Date de téléversement",
      expectedDate: "Attendu le",
      activationDate: "Activation vers le",
      note: "Ces délais sont indicatifs (environ 7 jours ouvrés au total). Ils peuvent varier selon la date à laquelle le paiement est crédité et la charge du service financier.",
      verifiedTitle: "Paiement vérifié",
      verifiedMessage: "Votre paiement a été vérifié. Votre adhésion est en cours d'émission : la lettre de bienvenue suit généralement sous 4 jours ouvrés environ.",
      addTitle: "Ajouter un autre justificatif de paiement",
      addHint: "Si le service financier vous en demande davantage, ou si vous disposez d'un relevé bancaire, d'un avis de débit ou d'un SWIFT MT103, ajoutez-le ici. Tous vos documents sont regroupés pour la vérification.",
      addButton: "Ajouter un document",
      added: "Document ajouté",
      documentsTitle: "Documents envoyés",
    },
    paymentDone: {
      title: "Paiement validé",
      message: "Votre paiement a été confirmé par le service financier. Vous recevrez votre lettre de bienvenue et les informations de votre carte de membre par e-mail prochainement.",
      verified: "Paiement vérifié ✓",
      nextStepsTitle: "Prochaines étapes",
      step1: "Vous recevrez votre lettre de bienvenue par e-mail",
      step2: "Votre carte de membre sera préparée",
      step3: "Nous vous contacterons pour le rendez-vous d'apposition du visa",
      package: "Votre adhésion",
    },
    prePayment: {
      title: "Avis important avant tout paiement",
      intro: "N'effectuez aucun paiement si l'une des situations suivantes vous concerne.",
      conditions: [
        {
          title: "Validité du tampon d'entrée",
          detail: "L'autorisation de séjour figurant sur le tampon d'entrée de votre passeport doit être valide. Un demandeur ayant un dépassement de séjour enregistré durant le séjour en cours ne peut en aucun cas obtenir un visa Thailand Privilege.",
        },
        {
          title: "Visa Non-Immigrant O (Volontariat)",
          detail: "Un demandeur qui détient actuellement, ou a détenu à un moment quelconque, un visa Non-Immigrant de type O (Volontariat) ne peut en aucun cas obtenir un visa Thailand Privilege.",
        },
        {
          title: "Visa Non-Immigrant MT ou ED",
          detail: "Un demandeur détenant actuellement un visa Non-Immigrant MT (traitement médical) sans le rapport hospitalier ou le certificat médical requis, ou un visa Non-Immigrant ED (études) sans le document officiel délivré par l'Office of Basic Education Commission (OBEC) et ses pièces justificatives, ne peut en aucun cas obtenir un visa Thailand Privilege.",
        },
      ],
      warning: "Si l'une des situations ci-dessus vous concerne, Thailand Privilege Card Co., Ltd. se réserve le droit de retenir les frais d'adhésion sans aucun remboursement.",
      rulesTitle: "Conditions de paiement",
      rules: [
        { text: "Les frais d'adhésion doivent être réglés en une seule transaction, conformément à l'Anti-Money Laundering Act, B.E. 2542 (1999) et à ses amendements. Un virement effectué depuis une application bancaire mobile doit également correspondre au montant total en une seule opération." },
        { text: "Le montant reçu par Thailand Privilege Card Co., Ltd. doit correspondre à l'intégralité des frais d'adhésion. Tous les frais bancaires, frais de banque intermédiaire, commissions d'agent et autres frais de transfert locaux ou internationaux restent à votre charge." },
        { text: "La lettre d'approbation et la facture sont valables 30 jours à compter de leur date d'émission. Un dossier expiré fait l'objet d'une nouvelle vérification des antécédents." },
        { text: "Tout paiement effectué après la date d'échéance indiquée sur la facture sera refusé et ne pourra bénéficier d'aucune offre promotionnelle." },
        { text: "Les cartes American Express ne sont pas acceptées." },
      ],
      doubt: "Si vous n'êtes pas certain qu'une de ces conditions vous concerne, contactez-nous avant de payer. Nous pouvons examiner votre dossier au préalable.",
    },

    visaAffix: {
      title: "Demander l'apposition du visa",
      intro: "Envoyez la demande à notre équipe : nous y joignons les documents déjà présents dans votre dossier, la transmettons au Member Contact Center et suivons la prise de rendez-vous.",
      locationLabel: "Lieu souhaité pour l'apposition",
      locations: {
        chaengWattana: "Bureau de l'immigration de Chaeng Wattana, Bangkok",
        suvarnabhumi: "Aéroport de Suvarnabhumi, à l'arrivée",
        phuket: "Aéroport international de Phuket, à l'arrivée",
        chiangMai: "Aéroport international de Chiang Mai, à l'arrivée",
        overseas: "Hors de Thaïlande (e-Visa via une représentation thaïlandaise)",
      },
      noticeThailand: "Les rendez-vous requièrent un préavis de 5 à 7 jours ouvrés et dépendent de la disponibilité d'un Elite Personal Liaison.",
      noticeOverseas: "Un e-Visa est délivré via le portail officiel du gouvernement thaïlandais. Comptez 15 à 30 jours ouvrés à compter de la soumission.",
      dateLabel: "Date souhaitée",
      flightLabel: "Vol d'arrivée",
      flightPlaceholder: "ex. TG911, 14 oct.",
      documentsLabel: "Documents de votre dossier",
      documentsHint: "Cochez ce que nous devons joindre. Tout est inclus par défaut.",
      documentTypes: {
        passport_photo: "Passeport",
        application_form: "Formulaire de demande",
        consent_form: "Formulaire de consentement",
        payment_proof: "Preuve de paiement",
      },
      submit: "Rédiger la demande",
      mccTitle: "Member Contact Center",
      mccHint: "Pour organiser vous-même le rendez-vous, contactez directement le MCC en indiquant votre numéro de membre.",
      email: {
        subject: "Demande d'apposition de visa",
        intro: "Je souhaite demander un rendez-vous pour l'apposition du visa Privilege Entry.",
        member: "Membre",
        card: "N° de membre",
        package: "Programme",
        location: "Lieu souhaité",
        preferredDate: "Date souhaitée",
        flight: "Vol d'arrivée",
        documentsHeld: "Merci de joindre depuis mon dossier",
        noneSelected: "Aucun document sélectionné",
        notSpecified: "Non précisé",
        closing: "Avec mes remerciements.",
      },
    },

    active: {
      title: "Bienvenue chez Thailand Elite !",
      subtitle: "Félicitations — vous êtes maintenant membre officiel de Thailand Elite.",
      cardNo: "N° de membre",
      package: "Programme",
      validFrom: "Valide du",
      validUntil: "Valide jusqu'au",
      requestVisaAffix: "Demander l'apposition du visa",
      memberArea: "Tableau de bord membre",
    },
    rejected: {
      title: "Demande non approuvée",
      titleCancelled: "Demande annulée",
      message: "Malheureusement, votre demande n'a pas pu être approuvée. Si vous avez des questions concernant cette décision, veuillez contacter notre équipe de support.",
      messageCancelled: "Cette demande a été annulée. Si vous souhaitez postuler à nouveau, vous pouvez créer une nouvelle demande.",
      messageInactive: "Cette demande a été clôturée après une longue période sans activité. Tout ce que vous avez saisi est conservé — vous pouvez reprendre là où vous en étiez.",
      resume: "Reprendre ma demande",
      resumedToast: "Bon retour ! Votre demande est de nouveau ouverte.",
      resumeFailed: "Nous n'avons pas pu rouvrir cette demande. Veuillez nous envoyer un message.",
      info: "Vous pouvez créer une nouvelle demande si vous souhaitez postuler à nouveau.",
      startNew: "Créer une nouvelle demande",
    },
  },

  auth: {
    login: {
      title: "Espace Membre",
      subtitle: "Connectez-vous à votre compte",
      email: "E-mail",
      continueWithEmail: "Continuer avec l'e-mail",
      sendingLink: "Envoi du lien…",
      noPasswordNote: "Nous vous enverrons un lien de connexion sécurisé — aucun mot de passe requis.",
      noAccount: "Pas encore de compte ?",
      createOne: "Créer un compte",
      // Email sent state
      checkEmailTitle: "Vérifiez votre e-mail",
      checkEmailDesc: "Nous avons envoyé un lien de connexion à <strong>{{email}}</strong>. Cliquez sur le lien pour accéder à votre compte.",
      didntReceive: "Vous ne l'avez pas reçu ?",
      tryAgain: "Réessayer",
      // Account disabled state
      accountDisabledTitle: "Compte désactivé",
      accountDisabledMsg: "Votre compte a été désactivé.",
      accountDisabledReason: "Raison :",
      accountDisabledContact: "Si vous pensez qu'il s'agit d'une erreur, contactez-nous à",
    },
    register: {
      title: "Créer un compte",
      subtitle: "Commencez votre parcours Thailand Elite",
      firstName: "Prénom",
      lastName: "Nom",
      email: "E-mail",
      phoneNumber: "Numéro de téléphone",
      searchCountry: "Rechercher un pays…",
      continueWithEmail: "Continuer avec l'e-mail",
      sendingLink: "Envoi du lien magique…",
      noPasswordNote: "Nous vous enverrons un lien sécurisé pour vérifier votre e-mail et vous connecter — aucun mot de passe requis.",
      alreadyHaveAccount: "Déjà un compte ?",
      signIn: "Se connecter",
      // Email sent state
      checkEmailTitle: "Vérifiez votre e-mail",
      checkEmailDesc: "Nous avons envoyé un lien magique à <strong>{{email}}</strong>. Cliquez sur le lien dans votre e-mail pour vous connecter et finaliser votre inscription.",
      didntReceive: "Vous ne l'avez pas reçu ?",
      tryAgain: "Réessayer",
    },
  },
};
